import { useState } from "react";
import { Link } from "react-router-dom";
import { resolveUrl } from "@/lib/api";
import { joinStyles } from "@/lib/format";

export const Thumb = ({ src, alt, className = "" }) => {
  const [broken, setBroken] = useState(false);
  return (
    <div className={`rounded-xl bg-[#D9D9D9] overflow-hidden ${className}`}>
      {src && !broken && (
        <img
          src={resolveUrl(src)}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-105"
          onError={() => setBroken(true)}
          loading="lazy"
        />
      )}
    </div>
  );
};

export const VideoCard = ({ video, compact = false }) => (
  <Link to={`/watch/${video.id}`} className="block group" data-testid={`video-card-${video.id}`}>
    <Thumb src={video.thumbnail_url} alt={video.title} className="aspect-[315/185]" />
    <h3 className={`${compact ? "mt-3 text-[15px]" : "mt-3 md:mt-4 lg:mt-5 text-[17px] md:text-[19px] lg:text-[22px] 4xl:text-[26px]"} font-bold leading-tight line-clamp-2`} data-testid="video-card-title">
      {video.title}
    </h3>
    <p className={`${compact ? "text-[12px]" : "text-[13px] md:text-[14px] lg:text-[15px] mt-0.5"} font-medium text-[#8A8A8A] ml-0.5 truncate`} data-testid="video-card-styles">
      {joinStyles(video.dance_styles)}
    </p>
  </Link>
);
